//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CompilationItem from "~/components/compilations/CompilationItem"
import {getContentByCode} from "@/utils/utils";
export default {
  components: {
    CompilationItem
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    sectionId: {
      type: Number,
      required: true
    },
    sectionCode: {
      type: String,
      required: true
    },
    view: {
      type: String,
      required: false,
      default: 'v'
    },
    textFoAllComp: {
      type: String,
      required: false,
      default: `Все подборки<br>раздела`
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: `.swiper-btn-next`,
          prevEl: `.swiper-btn-prev`
        },
        on: {
          init: function () {
            setTimeout(() => {
              this.updateSlides()
              // временный фикс бага с пагинацией
              this.slideTo(1)
              this.slideTo(0)
            }, 500)
          },
        }
      }
    }
  },
  computed: {
    isHasNav () {
      return this.items && this.items.length > this.swiperOption.slidesPerView
    }
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'comp-mobslider-texts',
        auto: true,
        params: {
          code: ['podborki-show-more'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
